export default __webpack_public_path__ + "static/media/section1-measure2.5a38d4c1.svg";